var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.relatedEntityType === "Stop"
    ? _c(
        "div",
        [
          _vm._v("\n    Stop\n    "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "Stop Details",
                  params: { stopId: _vm.item.relatedEntityId },
                },
                target: "_blank",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.item.reference) + "\n    ")]
          ),
        ],
        1
      )
    : _vm.item.relatedEntityType === "Trip"
    ? _c(
        "div",
        [
          _vm._v("\n    Trip\n    "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "Trip Details",
                  params: { tripId: _vm.item.relatedEntityId },
                },
                target: "_blank",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.item.reference) + "\n    ")]
          ),
        ],
        1
      )
    : _vm.item.relatedEntityType === "Shipment"
    ? _c(
        "div",
        [
          _vm._v("\n    Shipment\n    "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "Shipment Details",
                  params: { shipmentId: _vm.item.relatedEntityId },
                },
                target: "_blank",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.item.reference) + "\n    ")]
          ),
        ],
        1
      )
    : _vm.item.relatedEntityType === "CustomerInvoice"
    ? _c(
        "div",
        [
          _vm._v("\n    Customer Invoice\n    "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "Customer Invoice Details",
                  params: { invoiceId: _vm.item.relatedEntityId },
                },
                target: "_blank",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.item.reference) + "\n    ")]
          ),
        ],
        1
      )
    : _vm.item.relatedEntityType === "TeamMemberInvoice"
    ? _c(
        "div",
        [
          _vm._v("\n    Team Member Invoice\n    "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "Team Member Invoice Details",
                  params: { invoiceId: _vm.item.relatedEntityId },
                },
                target: "_blank",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.item.reference) + "\n    ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }